module.exports = __webpack_public_path__ + "img/Frage4_768x1024.1178f598.jpg";